export { default as translations } from './locales/en-GB/translations.json';
export { default as locales } from './locales/locales.json';
export const DEFAULT_LOCALE = 'en-GB';
export const COMMON_NAMESPACE = 'common';

export type Locale = { code: string; name: string; isDefault?: boolean };

export const getCurrentLanguage = (
  language: string,
  availableLocales: Array<Locale>,
): string => {
  const availableLocaleCodes = availableLocales.map((locale) => locale.code);
  return availableLocaleCodes.includes(language)
    ? language
    : (availableLocales.find((locale) => locale.isDefault)?.code ?? language);
};
